import { useSpring } from '@react-spring/web';

import { selectAppPersistSidebarResponse } from '@store/useAppStorePersist';

const useGetTextAppearanceAnimation = () => {
  const sidebarResponse = selectAppPersistSidebarResponse();

  const textAnimationStyles = useSpring({
    from: { opacity: 0, transform: 'translateX(100%)', left: '100%' },
    to: {
      opacity: sidebarResponse ? 0 : 1,
      transform: sidebarResponse ? 'translateX(100%)' : 'translateX(0%)',
      left: sidebarResponse ? '100%' : '0%',
      display: sidebarResponse ? 'none' : 'block',
    },
    config: {
      duration: 500,
      tension: 120,
      friction: 14,
    },
  });
  return { textAnimationStyles };
};

export default useGetTextAppearanceAnimation;
